<template>
  <div id="plvPPt" class="c-pc-ppt" :class="{ switch: docState }">
    <div class="ppt-container">
      <div class="have-ppt" v-if="isHavePpt && playerType !== 'polyv'">
        <div class="ppt-toolbar" v-show="ratio != 0">
          <div class="icon-zoomIn" @click="onZoomInBtn"></div>
          <div class="ppt-ratio">{{ ratio }}%</div>
          <div class="icon-zoomOut" @click="onZoomOutBtn"></div>
        </div>
        <div
          class="ppt-prev"
          v-if="pptIsAllowTurnPage"
          v-show="pptCurrentPageIndex > 1"
          @click="onPrev"
        ></div>
        <div
          class="ppt-next"
          v-if="pptIsAllowTurnPage"
          v-show="pptCurrentPageIndex < pptTotalPage"
          @click="onNext"
        ></div>
        <div
          class="ppt-page"
          v-if="pptIsAllowTurnPage && !isPlayBackStatus"
          v-show="pptCurrentPageIndex != 0 && pptTotalPage != 0"
        >
          {{ pptCurrentPageIndex }} / {{ pptTotalPage }}
        </div>
        <img
          class="ppt-source"
          ref="pptPic"
          v-if="pptUrl !== '' && pptIsOpen"
          :src="pptUrl"
          alt=""
        />
        <img
          class="ppt-default"
          v-if="pptUrl == '' && pptIsOpen"
          :src="defaultUrls"
        />
      </div>
      <div class="no-ppt" v-show="!isHavePpt">
        <div class="ppt-default">
          <img :src="defaultUrls" alt="" v-show="!docState" />
          <img :src="defaultUrl" alt="" v-show="docState" />
        </div>
      </div>
    </div>
    <div class="switch-box">
      <div class="switch-btn" @click="onSwitchDoc"></div>
    </div>
    <!--    polyv 控件-->
    <div class="ppt-container-polyv" v-if="isHavePpt && playerType == 'polyv'">
      <div class="have-ppt">
        <div
          class="ppt-prev"
          v-if="pptIsAllowTurnPage"
          v-show="pptCurrentPageIndex > 1"
          @click="onPrev"
        ></div>
        <div
          class="ppt-next"
          v-if="pptIsAllowTurnPage"
          v-show="
            pptCurrentPageIndex < pptTotalPage &&
              (playerType == 'polyv'
                ? pptCurrentPageIndex < polyvMaxPptPage
                  ? true
                  : false
                : true)
          "
          @click="onNext"
        ></div>
        <div
          class="ppt-page"
          v-if="pptIsAllowTurnPage && !isPlayBackStatus"
          v-show="pptCurrentPageIndex != 0 && pptTotalPage != 0"
        >
          {{ pptCurrentPageIndex }} / {{ pptTotalPage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/common/viewer/viewer.css";
import Viewer from "@/common/viewer/viewer";
import { $subscriber } from "fire-wind-water";
import $ from "jquery";
import { socketModule } from "../../common/socket";
import URL from "../../assets/conf/setting.json";

export default {
  name: "Ppt",
  data() {
    return {
      defaultUrls: require("../../assets/images/ppt/ppt-default-s.jpg"),
      defaultUrl: require("../../assets/images/ppt/ppt-default.jpg"),
      pptUrl: "", // 当前ppt地址
      pptCurrentPageIndex: 0, // 当前ppt页码
      pptTotalPage: 0, // ppt总页数
      pptIsOpen: false, // ppt是否显示
      pptIsAllowTurnPage: false, // ppt是否允许用户自主切换
      viewer: null,
      isPlayBackStatus: false,
      isHavePpt: false,
      playerType: "",
      polyvMaxPptPage: 0, //适配保利未 新加字段 ppt跟随模式最大可切换页码数
      webinarInfo: {}
    };
  },
  computed: {
    ratio() {
      if (this.viewer && this.viewer.imageData.ratio) {
        return (this.viewer.imageData.ratio * 100).toFixed();
      } else {
        return 0;
      }
    },
    docState: {
      get() {
        return this.$store.state.docState;
      },
      set(val) {
        return (this.$store.state.docState = val);
      }
    }
  },
  watch: {
    docState() {
      this.resizePPt();
    }
  },
  mounted() {
    let _this = this;
    window.$sk.webinar.module({
      //ppt发生改变
      skPptInfoChange(res) {
        /// 如果是保利威并且没有ppt 那么修改广播的值
        if (_this.webinarInfo.webCastProvider == "polyv") {
          if (!_this.webinarInfo.isPolyvHavePpt) {
            res[0].pptIsOpen = false;
          }
          $subscriber.emit("pptInfoChange", res[0]);
        } else {
          $subscriber.emit("pptInfoChange", res[0]); //发布播放器是回放状态
        }
      },
      //播放器状态
      skPlayerStatus(res) {
        let data = res[0];
        _this.isPlayBackStatus = data.content.data == "直播回放" ? true : false;
      }
    });
    $subscriber.subscribe("webinarInfo", data => {
      _this.playerType = data.webCastProvider;
      _this.webinarInfo = data;
    });
    $subscriber.subscribe("changeScreenStatus", () => {
      this.resizePPt();
    });
    //监听 ppt改变 消息
    $subscriber.subscribe("pptInfoChange", pptInfo => {
      let {
        pptCurrentPageIndex,
        pptTotalPage,
        pptUrl,
        pptIsOpen,
        pptIsAllowTurnPage,
        isHavePpt
      } = pptInfo;
      _this.pptCurrentPageIndex = pptCurrentPageIndex;
      _this.pptTotalPage = pptTotalPage;
      _this.pptUrl = pptUrl;
      _this.pptIsOpen = pptIsOpen;
      _this.pptIsAllowTurnPage = pptIsAllowTurnPage;
      _this.isHavePpt = isHavePpt;

      if (!pptIsOpen) {
        if (_this.docState) {
          _this.onSwitchDoc();
        }
      }
      if (!isHavePpt) {
        _this.pptUrl = "";
        if (document.querySelector(".pv-placeholder-zh_CN")) {
          document.querySelector(".pv-placeholder-zh_CN").style.display =
            "none";
        }
        if (document.querySelector(" .pv-ppt-layout")) {
          document.querySelector(".pv-ppt-layout").style.display = "none";
        }
        if (document.querySelector(".ppt-container")) {
          document.querySelector(".ppt-container").style.display = "block";
          document.querySelector(".ppt-container").style.position = "absolute";
        }
      } else {
        if (document.querySelector(".pv-ppt-layout")) {
          document.querySelector(".pv-ppt-layout").style.display = "block";
        }

        if (_this.playerType !== "polyv") {
          if (document.querySelector(".ppt-container")) {
            document.querySelector(".ppt-container").style.display = "block";
          }
        } else {
          if (document.querySelector(".ppt-container")) {
            document.querySelector(".ppt-container").style.display = "none";
          }
        }
      }
      //如果是 保利威播放器  清楚原有样式
      if (_this.playerType == "polyv") {
        //左右切换样式
        let pcPptNav = $(".ppt-h5-setting-pc-nav-mini");
        if (pcPptNav) {
          pcPptNav.remove();
        }
        //页面样式
        let pcPptpage = $("#pptH5ToastForMobile");
        if (pcPptpage) {
          pcPptpage.remove();
        }
        window.$sk.webinar.skSdkEvent({ type: "polyvResizePpt", data: {} });
        //保利威最大切换ppt 页码数
        //若 传来的当前页码数大于存的页码数复制，否则 不赋值
        _this.polyvMaxPptPage =
          pptCurrentPageIndex > _this.polyvMaxPptPage
            ? pptCurrentPageIndex
            : _this.polyvMaxPptPage;
      }
      if (pptUrl && isHavePpt) {
        // 初始化ppt插件
        _this.$nextTick(() => {
          setTimeout(() => {
            window.$sk.webinar.skPptEvent({
              type: "initPPt",
              data: {
                id: _this.$refs.pptPic
              }
            });
          }, 100);
          // window.viewer = _this.viewer = new Viewer(this.$refs.pptPic, {
          //   inline: true,
          //   button: false,
          //   fullscreen: false,
          //   toolbar: false,
          //   navbar: false,
          //   title: false
          // });
          // // _this.resizePPt();
        });
      }
    });
    $subscriber.subscribe("pptIsOpenIsFalse", status => {
      if (!status) {
        if (_this.docState) {
          _this.onSwitchDoc();
        }
      }
    });
    $subscriber.subscribe("switchMainScreen", status => {
      if (status == "ppt") {
        this.docState = false;
        this.onSwitchDoc();
      } else {
        this.docState = true;
        this.onSwitchDoc();
      }
    });
  },
  created() {},
  methods: {
    resizePPt() {
      this.$nextTick(() => {
        // if (this.viewer) {
        //   this.viewer.resize();
        // }
        window.$sk.webinar.skPptEvent({
          type: "resizePPt",
          data: {}
        });
      });
    },
    // 自定义控制项包括：上一页，下一页，放大，缩小
    onPrev() {
      this.pptCurrentPageIndex -= 1;
      if (this.playerType == "mudu") {
        window.$sk.webinar.skPptEvent({
          type: "onPrev",
          data: {
            val: this.pptCurrentPageIndex
          }
        });
      } else {
        window.$sk.webinar.skSdkEvent({
          type: "onPrev"
        });
      }
    },
    onNext() {
      this.pptCurrentPageIndex += 1;
      if (this.playerType == "mudu") {
        window.$sk.webinar.skPptEvent({
          type: "onNext",
          data: {
            val: this.pptCurrentPageIndex
          }
        });
      } else {
        window.$sk.webinar.skSdkEvent({
          type: "onNext"
        });
      }
    },
    onZoomOutBtn() {
      // this.viewer.zoom(-0.1);
      window.$sk.webinar.skPptEvent({
        type: "onZoomOutBtn",
        data: {
          val: -0.1
        }
      });
    },
    onZoomInBtn() {
      window.$sk.webinar.skPptEvent({
        type: "onZoomInBtn",
        data: {
          val: 0.1
        }
      });
    },
    onSwitchDoc() {
      this.$store.commit("setDocState", !this.docState);
      if (this.isHavePpt && this.playerType == "polyv") {
        //如果是 保利威 播放器，调保利威sdk
        window.$sk.webinar.skSdkEvent({ type: "polyvResizePpt", data: {} });
      }
    }
  }
};
</script>
